import {
  chartStatusDarkenCoefficient,
  lightModeChartStatusColors,
  uiTokens,
} from '../../theme/uiTokens';
import { darken } from './colorUtils';
import type { PaletteMode } from './types';

type StackedBarChartStatusColors = typeof uiTokens.statusColors;

const stackedBarChartPaletteOrder: Array<keyof StackedBarChartStatusColors> = [
  'purple',
  'green',
  'orange',
  'blue',
  'red',
];

export const resolveStackedBarChartStatusColors = (
  mode: PaletteMode,
): StackedBarChartStatusColors =>
  mode === 'light' ? lightModeChartStatusColors : uiTokens.statusColors;

export const buildStackedBarChartPalette = (statusColors: StackedBarChartStatusColors): string[] =>
  stackedBarChartPaletteOrder.map((key) => statusColors[key]);

const chartStatusColors = new Set(Object.values(uiTokens.statusColors));

export const resolveStackedBarChartBarColor = (base: string, mode: PaletteMode): string =>
  mode === 'dark'
    ? darken(base, chartStatusColors.has(base) ? chartStatusDarkenCoefficient : 0.26)
    : base;
